import { useEffect } from 'react';

function useDestructor(func: Function) {
  useEffect(() => () => func(), []);
}

export default useDestructor;
